import './polyfills'

import settings, { loadConfig } from 'settings'
import { DESIGN_QA_SCENARIOS_ENABLED, startDesignQaScenarios } from '@cloud-native/design-qa-scenarios'

const bootstrapApp = async () => {
  if (DESIGN_QA_SCENARIOS_ENABLED) {
    await startDesignQaScenarios(
      () => import('./devtools/designQa/initiatives').then(({ DESIGN_QA_INITIATIVES }) => DESIGN_QA_INITIATIVES),
      settings
    )
  }

  await loadConfig()

  const { renderApp } = await import('./ReactApp')
  renderApp()
}

bootstrapApp()
